module.exports = __webpack_public_path__ + "static/media/blank-status.a55bbb5a.svg";